import { BannerFieldsFragment } from '../../../@types/generated';
import { Paragraph, Label } from 'components/src/typography';
import TextWithInlineColor from '../TextWithInlineColor';
import clsx from 'clsx';
import ImageDesktop, { ImageMobile } from '@/components/Banner/BannerImage';
import { fullScreenChildGridClasses } from '@/styles/grid';
import ButtonSection from './ButtonSection';

type Props = {
  data: BannerFieldsFragment;
};

const renderHeading = ({ data }: Props) => {
  return (
    <TextWithInlineColor
      heading={data.heading?.text?.json}
      color={data.heading?.color}
      textColor={data.heading?.textColor}
      headingVariant={'xl'}
    />
  );
};

const BannerEdge = ({ data }: Props) => {
  return (
    <div className={`${fullScreenChildGridClasses} !block w-screen md:!grid`}>
      <ImageMobile image={data?.image} bannerType={'edge'} video={data.video} isImageFade={data.isImageFade} />
      {data.imagePosition === 'left' && (
        <ImageDesktop
          image={data.image}
          imagePosition="left"
          bannerType="edge"
          video={data.video}
          media={data.media}
          isImageFade={data.isImageFade}
        />
      )}
      <div
        className={
          `grid gap-16 px-32 md:col-span-6 md:place-self-center md:px-0 ` +
          `pt-${data.marginTop === 0 ? data.marginTop : data.marginTop || 32} ` +
          `pb-${data.marginBottom === 0 ? data.marginBottom : data.marginBottom || 32} ` +
          `${clsx({
            'md:col-start-8': data.imagePosition === 'left',
            'md:col-start-2': data.imagePosition === 'right',
          })}`
        }
      >
        {data.buttonsCollection?.items && (
          <div className={'flex flex-row gap-16 md:mt-24'}>
            {data.buttonsCollection.items.map((i, index) => (
              <ButtonSection key={`CTA-${index}`} data={i} classes={`text-${data.textColor}`} />
            ))}
          </div>
        )}
        {data.tagline && <Label classes={`text-${data.textColor} label-lg-normal`}>{data.tagline}</Label>}
        {data.heading?.text && renderHeading({ data })}
        {data.description && (
          <Paragraph variant={'title-lg'} classes={`whitespace-break-spaces text-${data.textColor}`}>
            {data.description}
          </Paragraph>
        )}
        {data.subdescription && (
          <Paragraph classes={`text-${data.textColor}`} variant="medium">
            {data.subdescription}
          </Paragraph>
        )}
        <ButtonSection data={data.button} classes={`grid pb-12 md:flex md:w-fit md:pb-0 text-${data.textColor}`} />
      </div>
      {data.imagePosition === 'right' && (
        <ImageDesktop
          image={data.image}
          imagePosition="right"
          bannerType="edge"
          video={data.video}
          media={data.media}
          isImageFade={data.isImageFade}
        />
      )}
    </div>
  );
};
export default BannerEdge;
